/**
 * Toast Utility Functions
 * Direct import functions for toast notifications
 */

import { useToastStore } from "./toastStore";

// Get the store instance to access addToast directly
const getToastStore = () => useToastStore.getState();

export const toast = {
  success: (message: string, duration?: number) =>
    getToastStore().addToast(message, "success", duration),
  error: (message: string, duration?: number) =>
    getToastStore().addToast(message, "error", duration),
  warning: (message: string, duration?: number) =>
    getToastStore().addToast(message, "warning", duration),
  info: (message: string, duration?: number) =>
    getToastStore().addToast(message, "info", duration),
};
